import { FC, useState } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

import { tabs } from './index';

import { InterwillInfoPanelStyledComponents } from './styles';

const { AnimatedWrapper, ContentContainer, NavContainer, Title } =
  InterwillInfoPanelStyledComponents;

type InterwillInfoPanelMobileProps = {
  preopened?: boolean;
};

export const InterwillInfoPanelMobile: FC<InterwillInfoPanelMobileProps> = ({ preopened }) => {
  const [openedMobileTabs, setOpenedMobileTabs] = useState<Record<number, boolean>>(
    preopened ? { 0: true, 1: true } : {},
  );

  return (
    <Container>
      <NavContainer>
        {tabs.map((item, idx) => {
          const isSelected = Boolean(openedMobileTabs[idx]);

          return (
            <NavItemContainer key={idx}>
              <NavItemHeadingContainer>
                <NavItemTitleContainer>
                  <Icon
                    key={idx}
                    name={item.iconName}
                    size="s20"
                    style={{ color: isSelected ? COLORS.blueColor : COLORS.grey }}
                  />
                  <Title style={{ color: isSelected ? COLORS.blueColor : COLORS.colorPrimary }}>
                    {item.title}
                  </Title>
                </NavItemTitleContainer>

                <IconWrapper>
                  <AnimatedIconWrapper $isSelected={isSelected}>
                    <Icon
                      name="caret-right"
                      size="s20"
                      onClick={() => {
                        setOpenedMobileTabs((p) => ({ ...p, [idx]: !isSelected }));
                      }}
                    />
                  </AnimatedIconWrapper>
                </IconWrapper>
              </NavItemHeadingContainer>

              <AnimatedWrapper $isOpen={isSelected}>
                <ContentContainer>{tabs[idx].content}</ContentContainer>
              </AnimatedWrapper>
            </NavItemContainer>
          );
        })}
      </NavContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  border-radius: 12px;
  background-color: ${COLORS.white};
`;

const NavItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  container-type: inline-size;
`;

const NavItemHeadingContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: space-between;
`;

const NavItemTitleContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 12px 8px;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const AnimatedIconWrapper = styled.div<{ $isSelected: boolean }>`
  transform: ${({ $isSelected }) => ($isSelected ? 'rotate(-90deg)' : 'rotate(90deg)')};
  transition: transform var(--ani-speed) ease-in-out;
  transform-origin: 10px 10px;
  cursor: pointer;
`;
